import * as React from 'react';
import ModuleData from './ModuleData';
import l10n from '../../util/l10n';
import { EditViewProps } from '../interfaces';
import ModulFliestext from '../ModulFliestext';
import { ToolbarItems } from '../../custom-components/ckeditor/CKEditorToolbar';
import { CKEditorEditView, CKEditorEditViewProps } from '../common/CKEditorEditView';
import { allCKEditorItems as CK } from '../../custom-components/ckeditor/AllCKEditorButtonsConfig';

import { TextFormat as TextFormatIcon } from '../../custom-components/svg-icons/TextFormat';
import AlignLeftIcon from 'material-ui/svg-icons/editor/format-align-left';

import FormatListBulletedIcon from 'material-ui/svg-icons/editor/format-list-bulleted';
import FormatIndentIncreaseIcon from 'material-ui/svg-icons/editor/format-indent-increase';
import ContentPasteIcon from 'material-ui/svg-icons/content/content-paste';

interface TextEditViewProps extends EditViewProps<ModuleData>, CKEditorEditViewProps {
    module: ModulFliestext;
}

export class TextEditViewTextBasics extends React.Component<TextEditViewProps, {}> {

    render() {
        const items: ToolbarItems = [];
        const {
            textFormat, textAlign, textIndent, textColor
        } = this.props.module.getData().supports;

        if (textFormat) {
            items.push(CK.FontSize);
        }
        if (textColor) {
            items.push(CK.DiyTextColor);
        }
        if (textFormat) {
            items.push(
                {
                    groupProps: {
                        label: l10n('module.text.buttongroups.format'),
                        Icon: <TextFormatIcon/>,
                        dataTestId: "text-module-format-menu"
                    },
                    items: [
                        CK.Bold,
                        CK.Italic,
                        CK.Underline,
                        CK.Strike,
                        CK.Superscript,
                        CK.Subscript,
                        CK.RemoveFormat
                    ]
                }
            );
        }
        if (textAlign) {
            items.push(
                {
                    groupProps: {
                        label: l10n('module.text.buttongroups.align'),
                        Icon: <AlignLeftIcon />,
                        dataTestId: "text-module-align-menu"
                    },
                    items: [ CK.JustifyLeft, CK.JustifyCenter, CK.JustifyRight, CK.JustifyBlock ]
                }
            );
        }
        items.push(
            {
                groupProps: {
                    label: l10n('module.text.buttongroups.list'),
                    Icon: <FormatListBulletedIcon />,
                    dataTestId: "text-module-list-menu"
                },
                items: [ CK.NumberedList, CK.BulletedList ]
            }
        );
        if (textIndent) {
            items.push(
                {
                    groupProps: {
                        label: l10n('module.text.buttongroups.indent'),
                        Icon: <FormatIndentIncreaseIcon />,
                        dataTestId: "text-module-indent-menu"
                    },
                    items: [ CK.Outdent, CK.Indent ]
                }
            );
        }
        items.push(CK.Link, CK.Unlink);

        return (
            <CKEditorEditView
                {...this.props}
                key="TextBasics"
                items={items}
            />
        );
    }
}

export class TextEditViewFormat extends React.Component<TextEditViewProps, {}> {

    render() {
        const items: ToolbarItems = [];
        const {
            textFormat, textHtmlEdit, textWordPaste
        } = this.props.module.getData().supports;
        if (textFormat) {
            items.push(CK.Format);
        }
        if (textWordPaste) {
            items.push(
                {
                    groupProps: {
                        label: l10n('module.text.buttongroups.paste'),
                        Icon: <ContentPasteIcon />,
                        dataTestId: "text-module-paste-menu"
                    },
                    items: [ CK.Paste, CK.PasteFromWord ]
                }
            );
        }

        items.push(CK.TextStyles(this.props.module));

        items.push(CK.ContactInfo);
        if (textHtmlEdit) {
            items.push(CK.SourceDialog);
        }

        return (
            <CKEditorEditView
                {...this.props}
                key="TextFormat"
                items={items}
            />
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/text/EditView.tsx
 **/